export const EXPERIENCE_OPTIONS = ["0", "1", "2", "3", "4", "5", "5+"].map((value) => ({
  label: value,
  value,
}));

export const CAR_QUOTE_STEP_KEYS = {
  PERSONAL_DETAILS: "personalDetails",
  VEHICLE_DETAILS: "vehicleDetails",
  DRIVER_DETAILS: "driverDetails",
  QUOTE_SELECTION: "quoteSelection",
  DOCUMENT_UPLOAD: "documentUpload",
  ADDITIONAL_INFO: "additionalInfo",
  PAYMENT: "payment",
} as const;

export type CarQuoteStepKey = (typeof CAR_QUOTE_STEP_KEYS)[keyof typeof CAR_QUOTE_STEP_KEYS];

export const currentInsurerOptions = [
  { label: "Aman", value: "Aman" },
  { label: "GIG Gulf", value: "GIG Gulf" },
  { label: "DNIRC", value: "DNIRC" },
  { label: "SUKOON", value: "SUKOON" },
  { label: "RAK Insurance", value: "RAK Insurance" },
  { label: "Liva", value: "Liva" },
  { label: "Salama", value: "Salama" },
];

export const currentPolicyTypeOptions = [
  { label: "Comprehensive", value: "Comprehensive" },
  { label: "Third Party", value: "Third Party" },
];

export const defaultMotorCurrentInsurerOptions = [
  {
    label: "Sukoon Insurance (Formerly known as Oman Insurance Company)",
    value: "Sukoon Insurance (Formerly known as Oman Insurance Company)",
  },
  {
    label: "GIG Gulf (Formerly known as AXA Gulf)",
    value: "GIG Gulf (Formerly known as AXA Gulf)",
  },
  {
    label: "Orient Insurance PJSC",
    value: "Orient Insurance PJSC",
  },
  {
    label: "Abu Dhabi National Insurance Company (ADNIC)",
    value: "Abu Dhabi National Insurance Company (ADNIC)",
  },
  {
    label: "Dubai Insurance Co.",
    value: "Dubai Insurance Co.",
  },
  {
    label: "Dubai National Insurance & Reinsurance (DNI)",
    value: "Dubai National Insurance & Reinsurance (DNI)",
  },
  {
    label: "Al Wathba National Insurance Company (AWNIC)",
    value: "Al Wathba National Insurance Company (AWNIC)",
  },
  {
    label: "Al Buhaira National Insurance Company",
    value: "Al Buhaira National Insurance Company",
  },
  {
    label: "Al Fujairah National Insurance Company (AFNIC)",
    value: "Al Fujairah National Insurance Company (AFNIC)",
  },
  {
    label: "SALAMA (Islamic Arab Insurance Co.)",
    value: "SALAMA (Islamic Arab Insurance Co.)",
  },
];

export const gccSpecOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const newCarOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const registeredUnderOptions = [
  { label: "Individual", value: "Individual" },
  { label: "Company", value: "Company" },
];

export const emirates = [
  { label: "Abu Dhabi", value: "abu_dhabi" },
  { label: "Dubai", value: "dubai" },
  { label: "Sharjah", value: "sharjah" },
  { label: "Ajman", value: "ajman" },
  { label: "Umm Al Quwain", value: "umm_al_quwain" },
  { label: "Ras Al Khaimah", value: "ras_al_khaimah" },
  { label: "Fujairah", value: "fujairah" },
];
